import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Link,
  Tooltip,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import * as _props from '../../../_redux/_services/JobPostingSlice';
import { Encrypt } from '../../../_utilities/_encryptDecryptHelper';
import { setBreadCrumb } from '../../../_utilities/breadCrumb';
import GetJobId from '../../../_utilities/GetJobId';
import { ApplicantEdit } from '../../../Icons/ApplicantEdit';
import { Clone } from '../../../Icons/Clone';
import PostingsComponent from '../PostingsComponent';

const initalState = { data: null, message: '', isloader: true };

const PostingsView = (props) => {
  const [viewJob, setViewJob] = useState(null);
  const [open, setOpen] = useState(false);
  const [showNoData, setShowNoData] = useState(false);

  const getJobCode = GetJobId();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const getDetails = useSelector((state) => state.Jobpostingsbyid.data);
  const showLoader = useSelector((state) => state.Loader.value);
  const showUncommonLoader = useSelector((state) => state.UncommonLoader.value);
  useEffect(() => {
    if (getJobCode) {
      dispatch(_props.jobpostingsbyidAsync(getJobCode));
    }
  }, [getJobCode]);

  useEffect(() => {
    if (props.getData) {
      // setViewJob(props.getData);
      dispatch(_props.jobpostingsbyidAsync(props.getData.jobopeningID));
    }
  }, [props.getData]);

  useEffect(() => {
    let timer;
    if (viewJob && viewJob.length === 0 && !showLoader && !showUncommonLoader) {
      timer = setTimeout(() => {
        setShowNoData(true);
      }, 2000);
    } else {
      setShowNoData(false);
    }
    return () => clearTimeout(timer);
  }, [viewJob, showLoader, showUncommonLoader]);

  useEffect(() => {
    if (location.state?.object) {
      let jobData = location.state.object;
      dispatch(_props.jobpostingsbyidAsync(jobData.jobopeningID));
    }
  }, [location]);

  useEffect(() => {
    if (getDetails !== null && getDetails !== undefined) {
      let postingData = JSON.parse(JSON.stringify(getDetails));
      postingData.jobType = postingData.jobType.split(',');
      postingData.recruiters = postingData.recruiters
        ? JSON.parse(postingData.recruiters)
        : [];
      postingData.clientName = {
        id: postingData.clientId,
        clientName: postingData.clientName,
      };
      setViewJob(postingData);
      let updateSkills = postingData.primarySkills.replace(/\n/g, ',');
      Encrypt(updateSkills, 'getSkills');
      localStorage.setItem('JobIdentifier', postingData.affindaIdentifier);
      let name = `${postingData.jobTitle} (${postingData.jobCode})`;
      setBreadCrumb(postingData.id, name, 'Job Code');
    }
  }, [getDetails]);

  const onGetValidData = (data) => {
    console.log(data);
  };

  const onCloneHandler = async () => {
    const customHeaders = { jobCode: viewJob.jobCode, userId: viewJob.userId };
    await dispatch(_props.getListofQuestionsAsync(viewJob.id, customHeaders));
    navigate('/ats/layout/jobpostings/create/jobdetails');
  };

  return (
    <div style={{ padding: '0 10px' }}>
      <div className="applicant-view-header" style={{ marginTop: '-118px' }}>
        <Tooltip title="Clone" placement="top">
          <div
            onClick={() => {
              setOpen(true);
            }}
          >
            <Clone />
          </div>
        </Tooltip>
        <Tooltip title="Edit" placement="top">
          <div
            onClick={() => {
              dispatch(_props.jobpostingsbyidStartReducer(initalState));
              navigate(`/ats/layout/jobpostings/edit/${getJobCode}`);
            }}
          >
            <ApplicantEdit />
          </div>
        </Tooltip>
      </div>
      {viewJob && viewJob.length !== 0 ? (
        <PostingsComponent
          componentType="view"
          input={viewJob}
          iniValue={viewJob}
          actions={null}
          onValidData={onGetValidData}
          getJobDetails={false}
        />
      ) : (
        showNoData && (
          <div className="nodatasection">
            <img
              src={process.env.PUBLIC_URL + '/assests/nodata.svg'}
              alt="noData"
            />
            {'No data found'}
          </div>
        )
      )}
      <Dialog
        open={open}
        keepMounted
        onClose={() => {
          setOpen(false);
        }}
        aria-describedby="alert-dialog"
        style={{ marginTop: '-26%' }}
      >
        <Box sx={{ width: '395px' }}>
          <DialogTitle className="diabtn">Confirm</DialogTitle>
          <DialogContent>
            <DialogContentText className="diabtnjob" id="alert-dialog">
              <p className="btntext">Are you sure you want to Clone ?</p>
            </DialogContentText>
          </DialogContent>
          <DialogActions className="warning-actionbtns">
            <Button
              onClick={() => {
                setOpen(false);
              }}
            >
              <Link href="#" color="#000" underline="always">
                Cancel
              </Link>
            </Button>
            <Button onClick={onCloneHandler}>Yes</Button>
          </DialogActions>
        </Box>
      </Dialog>
    </div>
  );
};

export default React.memo(PostingsView);
